<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg12>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Npos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="searchColumn"
              :items="filteredSearchColumn"
              item-text="text"
              item-value="value"
              label="Select column"
              return-object
              single-line
              hide-details
              class="mr-3"
              @input="customSearch"
              max-width="200px"
            ></v-select>
            <v-text-field
              v-model="tableSearch"
              append-icon="mdi-table-search"
              label="Search..."
              single-line
              hide-details
              @input="customSearch"
            ></v-text-field>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="tableData"
              :options.sync="options"
              :server-items-length="totalData"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
              </template>
              <template v-slot:item.name="{ item }">
                <a @click="goToNpo(item)" dark>{{ item.name }}</a>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="$router.push({ path: 'npos/' + item.fiscalCode, params: { fiscalCode: item.fiscalCode } })"
                >mdi-square-edit-outline</v-icon>
                <v-icon small @click="deleteNpo(item)">mdi-delete</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Table from '@/components/Table'
import apiService from '@/services'

// const apiService = new ApiService()

export default {
  watch: {
    options: {
      handler () {
        this.getNposFromApi()
      },
      deep: true
    },
    dialog (val) {
      val || this.closeModal()
    }
  },
  computed: {
    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.tableHeaders.filter(item => item.value !== 'action')
    }

  },
  data () {
    return {
      // Ricerca nella tabella
      searchColumn: '',
      tableSearch: '',
      tableSearchTimeout: false,
      // Npos table
      tableHeaders: [
        {
          text: 'Npo',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'CF',
          value: 'fiscal_code'
        },
        {
          text: 'Campaign',
          align: 'left',
          sortable: true,
          value: 'campaign'
        },
        { text: 'Status', value: 'status' },
        { text: 'Indirizzo', value: 'address' },
        { text: 'CAP', value: 'zipCode' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      options: {},
      totalData: 0,
      tableData: [],
      loading: true
    }
  },

  mounted () {
    this.getNposFromApi()
  },

  methods: {
    // GET delle npo
    getNposFromApi () {
      this.loading = true

      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.options

      // Setup search filter extending data-table componet option object
      // TO DO refactoring to use component and props (check if possible)
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage
      filter.orderDesc = sortDesc[0] || null

      filter.filterBy = this.tableSearch !== '' ? this.searchColumn.value : ''
      filter.filterValue = this.tableSearch || ''

      // GET on global entities search API endpoint
      apiService.fetchData('npos', filter).then(data => {
        setTimeout(() => {
          this.tableData = data
          this.totalData = data.lenght
          this.loading = false
        }, 800)
      }).catch(error => console.log(error))
    },

    // This will trigger when either of the search inputs is changed
    customSearch () {
      if (this.searchColumn !== '') {
        // Stop timeout to prevent search from firing while user is still typing
        clearTimeout(this.tableSearchTimeout)
        // Set a timeout to fire search after the user has stopped typing
        this.tableSearchTimeout = setTimeout(() => {
          this.getNposFromApi()
        }, 800)
      }
    },

    goToNpo (item) {
      this.$router.push({ path: 'npos/' + item.npo_id, params: { id: item.npo_id } })
    },

    // TO DO these methods will be implemented after first fase of development is completed - Riccardo Cosentino 04052020
    editNpo (npo) {
    },

    deleteNpo (npo) {
    },

    closeModal () {
    },

    addNpo () {
    },
    // END of methods to be implemented

    // Setup mock of statuses color since definitive set of statuses has not been provided yet
    // TO DO save statuses and properties in store - Riccardo Cosentino 04052020
    getStatusColor (status) {
      if (status === '1') return 'green'
      else if (status === '2') return 'red'
      else return 'gray'
    }
  }
}
</script>
